import React, { useState, useContext } from "react";
import {
  Divider,
  Row,
  Col,
  Form,
  Select,
  Input,
} from "antd";
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import FormItemAddress from "../../../formItems/address";
import FormItemAccountNumber from "../../../formItems/accountNumber";
import FormItemRoutingNumber from "../../../formItems/routingNumber";
import { backendPostWithoutRefresh } from "../../../../helpers/callBackend";
import GenericModal from "../../../buttons/genericModal";
import { PaymentsContext } from "../../../../helpers/contexts/PaymentsContext";
import { errorMessage } from "../../../../helpers/errorMessageFunc";
import RecipientCanOptOutMessage from "./RecipientCanOptOutMessage";
import checkFlag from "../../../../helpers/featureFlags";

const { Option } = Select;
var formRef = React.createRef();

function AddRecipientButton(props) {
  const { dispatch, state } = useContext(PaymentsContext);
  const [current, setCurrent] = useState(0);
  const [formInputs, setFormInputs] = useState({});
  const [visible, setVisible] = useState(false);

  // allow dwolla customer creation/editing only if paymnentsV2 flag is enabled and user is a software customer
  const dwollaCreate = checkFlag('paymentsV2') && JSON.parse(localStorage.getItem("isSoftwareCustomer"))

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleChange = (input) => (e) => {
    if (typeof e === "string" || typeof e === "number") {
      setFormInputs((prevState) => ({
        ...prevState,
        [input]: e,
      }));
    } else if (e.target !== undefined) {
      setFormInputs((prevState) => ({
        ...prevState,
        [input]: e.target.value,
      }));
    } else {
      setFormInputs((prevState) => ({
        ...prevState,
        [input]: e.format("YYYY-MM-DD"),
      }));
    }
  };

  const validateForm = () => {
    var data = { ...formInputs };
    if (!("name" in data) || data["name"] === "") return [false, "name"];
    if (!("routingNumber" in data) || data["routingNumber"] === "")
      return [false, "routingNumber"];
    if (!("accountNumber" in data) || data["accountNumber"] === "")
      return [false, "accountNumber"];
    if (!("accountType" in data) || data["accountType"] === "")
      return [false, "accountType"];
    if (!("vendorType" in data) || data["vendorType"] === "")
      return [false, "vendorType"];
    if (!("accountStreetLine1" in data) || data["accountStreetLine1"] === "")
      return [false, "accountStreetLine1"];
    if (!("accountCity" in data) || data["accountCity"] === "")
      return [false, "accountCity"];
    if (!("accountState" in data) || data["accountState"] === "")
      return [false, "accountState"];
    if (!("accountZipCode" in data) || data["accountZipCode"] === "")
      return [false, "accountZipCode"];
    if (!("bankName" in data) || data["bankName"] === "")
      return [false, "bankName"];
    if (!("bankStreetLine1" in data) || data["bankStreetLine1"] === "")
      return [false, "bankStreetLine1"];
    if (!("bankCity" in data) || data["bankCity"] === "")
      return [false, "bankCity"];
    if (!("bankState" in data) || data["bankState"] === "")
      return [false, "bankState"];
    if (!("bankZipCode" in data) || data["bankZipCode"] === "")
      return [false, "bankZipCode"];

    return [true, ""];
  };

  const onFormSubmitModal = (values) => {
    var validateResponse = validateForm();
    if (validateResponse[0]) {
      var data = Object.assign({}, state, formInputs);
      if (data["accountStreetLine2"] === undefined) {
        data["accountStreetLine2"] = "";
      }
      if (data["bankStreetLine2"] === undefined) {
        data["bankStreetLine2"] = "";
      }
      if (data["nickname"] === undefined) {
        data["nickname"] = data["name"];
      }
      data["dwolla_create"] = dwollaCreate

      dispatch({
        type: "REQUEST_START",
      });

      backendPostWithoutRefresh("/api/payments/counterparty/", data)
        .then((response) => {
          dispatch({
            type: "ADD_RECIPIENT",
            payload: { newRecipientData: response.data.data },
          });

          if (formRef.current) {
            formRef.current.resetFields();
            setFormInputs({});
          }

          if (props.onSuccessFunc) {
            props.onSuccessFunc(response.data.data);
          }
          const newRecipient = response.data.data;
          props.setRecipients((prev) => [...prev, newRecipient].sort((a, b) => {
            const nameA = a?.retrieved_values?.name || "";
            const nameB = b?.retrieved_values?.name || "";
            return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
          }))
          props.setShowRecipients((prev) => [...prev, newRecipient].sort((a, b) => {
            const nameA = a?.retrieved_values?.name || "";
            const nameB = b?.retrieved_values?.name || "";
            return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
          }))

          setVisible(false);
        })
        .catch((error) => {
          console.error(error);
          dispatch({
            type: "REQUEST_END",
          });
        });
    } else {
      errorMessage(
        "Enter " +
        validateResponse[1]
          .split(/(?=[A-Z])/)
          .join(" ")
          .toUpperCase() +
        " Value"
      );
    }
  };

  const content = [
    <div style={{ padding: "5%" }}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Legal Name/Name on Account"
            name="name"
            rules={[
              {
                required: true,
                message: "Provide name on account.",
              },
              { max: 50, message: "Legal Name must not exceed 50 characters" },
            ]}
            onChange={handleChange("name")}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Nickname"
            name="nickname"
            onChange={handleChange("nickname")}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true }]}
            onChange={handleChange("email")}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <FormItemRoutingNumber
            label="Routing Number"
            name="routingNumber"
            onChange={handleChange("routingNumber")}
          />
        </Col>
        <Col span={8}>
          <FormItemAccountNumber
            label="Account Number"
            name="accountNumber"
            onChange={handleChange("accountNumber")}
          />
        </Col>
        <Col span={8}>
          <Form.Item
            label="Account Type"
            name="accountType"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select your Account Type"
              style={{ width: "100%" }}
              dropdownMatchSelectWidth={false}
              onChange={handleChange("accountType")}
              allowClear
            >
              <Option value="checking">Checking</Option>
              <Option value="savings">Savings</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="Vendor Type"
            name="vendorType"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select your Vendor Type"
              style={{ width: "100%" }}
              dropdownMatchSelectWidth={false}
              onChange={handleChange("vendorType")}
              allowClear
            >
              <Option value="business">Business</Option>
              <Option value="personal">Personal</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <h4>Account Holder Address</h4>
      <Divider style={{ marginTop: "5px" }} />

      <FormItemAddress
        streetLine1={"accountStreetLine1"}
        streetLine2={"accountStreetLine2"}
        city={"accountCity"}
        state={"accountState"}
        zipCode={"accountZipCode"}
        onChange={(value) => handleChange(value)}
      />
    </div>,
    <div style={{ padding: "5%" }}>
      <Form.Item
        label="Bank Name"
        name="bankName"
        rules={[{ required: true }]}
        onChange={handleChange("bankName")}
      >
        <Input />
      </Form.Item>

      <FormItemAddress
        streetLine1={"bankStreetLine1"}
        streetLine2={"bankStreetLine2"}
        city={"bankCity"}
        state={"bankState"}
        zipCode={"bankZipCode"}
        onChange={(value) => handleChange(value)}
      />
    </div>,
    <div style={{ padding: "5%" }}>
      <>
        {checkFlag('paymentsV2') && dwollaCreate && <RecipientCanOptOutMessage />}
        <p style={{ marginBottom: "20px", fontWeight: 600, fontSize: "16px" }}>
          Review
        </p>
        <Divider orientation="left">Account Information</Divider>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Legal Name
          </Col>
          <Col span={10}>{formInputs.name ? formInputs.name : ""}</Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Nickname
          </Col>
          <Col span={10}>{formInputs.nickname ? formInputs.nickname : ""}</Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Email
          </Col>
          <Col span={10}>{formInputs.email ? formInputs.email : ""}</Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Routing Number
          </Col>
          <Col span={10}>
            {formInputs.routingNumber ? formInputs.routingNumber : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Account Number
          </Col>
          <Col span={10}>
            {formInputs.accountNumber ? formInputs.accountNumber : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Account Type
          </Col>
          <Col span={10}>
            {formInputs.accountType ? formInputs.accountType : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Vendor Type
          </Col>
          <Col span={10}>
            {formInputs.vendorType ? formInputs.vendorType : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Street Line 1
          </Col>
          <Col span={10}>
            {formInputs.accountStreetLine1 ? formInputs.accountStreetLine1 : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Street Line 2
          </Col>
          <Col span={10}>
            {formInputs.accountStreetLine2 ? formInputs.accountStreetLine2 : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            City
          </Col>
          <Col span={10}>
            {formInputs.accountCity ? formInputs.accountCity : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            State
          </Col>
          <Col span={10}>
            {formInputs.accountState ? formInputs.accountState : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Zip Code
          </Col>
          <Col span={10}>
            {formInputs.accountZipCode ? formInputs.accountZipCode : ""}
          </Col>
        </Row>
        <Divider orientation="left">Recipient Bank Information</Divider>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Bank Name
          </Col>
          <Col span={10}>{formInputs.bankName ? formInputs.bankName : ""}</Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Street Line 1
          </Col>
          <Col span={10}>
            {formInputs.bankStreetLine1 ? formInputs.bankStreetLine1 : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Street Line 2
          </Col>
          <Col span={10}>
            {formInputs.bankStreetLine2 ? formInputs.bankStreetLine2 : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            City
          </Col>
          <Col span={10}>{formInputs.bankCity ? formInputs.bankCity : ""}</Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            State
          </Col>
          <Col span={10}>
            {formInputs.bankState ? formInputs.bankState : ""}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={10} style={{ textAlign: "left" }}>
            Zip Code
          </Col>
          <Col span={10}>
            {formInputs.bankZipCode ? formInputs.bankZipCode : ""}
          </Col>
        </Row>
      </>
      <Divider />
      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <LoadingButton
          htmlType="submit"
          style={{
            margin: "3px",
            width: "50%",
          }}
          loadingPosition="start"
          loading={state.inFlight}
          disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
          sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
        >
          Submit
        </LoadingButton>
      </Form.Item>
    </div>,
  ];
  return (
    <GenericModal
      visible={visible}
      handleCancelModal={() => setVisible(false)}
      showModal={() => setVisible(true)}
      size="lg"
      button={<Button disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
        sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}>Add Recipient</Button>}
      modalTitle={"Add Recipient"}
      modalBody={
        <>
          <div className="steps-content">
            <Form
              layout="vertical"
              name="basic"
              onFinish={onFormSubmitModal}
              autoComplete="off"
              ref={formRef}
            >
              {content[current]}
            </Form>
          </div>
          <div className="steps-action" style={{ textAlign: "center" }}>
            {current > 0 && (
              <Button disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary"
                sx={{ fontSize: 14, width: '100px', textTransform: 'none' }} style={{ margin: "0 8px" }} onClick={() => prev()}>
                Previous
              </Button>
            )}
            {current < 2 && (
              <Button disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                sx={{ fontSize: 14, width: '100px', textTransform: 'none' }} onClick={() => next()}>
                Next
              </Button>
            )}
          </div>
        </>
      }
    />
  );
}

AddRecipientButton.defaultProps = {
  onSuccessFunc: () => {
    console.warn('onSuccessFunc is not defined');
  }
};

export default AddRecipientButton;


